// extracted by mini-css-extract-plugin
export default {"metaItem":"styles_metaItem__0PcdR","value":"styles_value__MH8Bm","icon":"styles_icon__lBvZn"};